import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "./static-init";

//do not remove this is for proto type extenstion for server date
import "@eres/core/dist/ServerDate";
//import * as serviceWorker from './serviceWorker';
import ReactHabitat from "react-habitat";
import HabitatFactory from "@my-dld/boot/HabitatFactory";
import { configureApp } from "./configApp";
import "react-toastify/dist/ReactToastify.css";
import "./extra.css";
import "./fetchHook";
import * as CoreApp from "@10x/coreapp";
import { getAppServices } from "@10x/coreapp";
import { rvModule as RVModule } from "@10x/rentalvaluation";
import { AddPropertyModule } from "@10x/addproperty";
import SvcStrings from "@my-dld/assets/strings/svc_description";
import { TabuProcedures, TabuRequestUtils } from "@10x/tabu-mobile-api";
import { HandTakeOverModule } from "./handtakeover";
import { regModule } from "@my-dld/screens/Register/ctx";

class MyApp extends ReactHabitat.Bootstrapper {
	constructor() {
		super();
		CoreApp.initApp( { mode: "web" } );
		// initModule(RVModule);
		CoreApp.addModule( RVModule );
		CoreApp.addModule( AddPropertyModule );
		CoreApp.addModule( HandTakeOverModule );
		CoreApp.addModule( regModule );
		TabuRequestUtils.addTabuServiceDescriptionToContainer( SvcStrings, TabuProcedures.OwnershipChange );
		TabuRequestUtils.addTabuServiceDescriptionToContainer( SvcStrings, TabuProcedures.PropertyCutOff );
		TabuRequestUtils.addTabuServiceDescriptionToContainer( SvcStrings, TabuProcedures.DelayedPropertyCutOff );
		getAppServices().assetService.registerStringProvider( {}, "main" );
		getAppServices().assetService.registerStringProvider( SvcStrings, "prop_svc_description" );
		CoreApp.preInit();
		CoreApp.preInitDone();
		CoreApp.initModules();
		CoreApp.initDone();
		configureApp();
		// Create a new container builder:
		const builder = new ReactHabitat.ContainerBuilder();
		// Register a component:
		builder.registerAsync( () => import("@my-dld/microapps/MainApp") ).as( "MyDLD" );
		builder.registerAsync( () => import("@my-dld/microapps/LoginMenu") ).as( "Me" )
		.withOptions( {
			tag: "li",
		} );
		builder.registerAsync( () => import("@my-dld/microapps/Transaction") ).as( "Transaction" );
		builder.registerAsync( () => import("@my-dld/microapps/BuyProperty") ).as( "BuyProperty" );
		builder.registerAsync( () => import("@my-dld/microapps/LogoutWrapper") ).as( "LogoutDialog" );
		builder.registerAsync( () => import("@my-dld/microapps/SSOApps") ).as( "SSOApps" );
		builder.registerAsync( () => import("@my-dld/microapps/VerifyEmail") ).as( "VerifyEmail" );
		builder.registerAsync( () => import("@my-dld/microapps/AskMalik") ).as( "AskMalik" );
		builder.registerAsync( () => import("@my-dld/microapps/FeesReceiptService") ).as( "FeesReceipt" );
		builder.registerAsync( () => import("@my-dld/microapps/FeesRefundService") ).as( "FeesRefund" );
		// Or register a component to load on demand asynchronously:
		// builder.registerAsync(() => import('SC')).as('SC');
		builder.factory = new HabitatFactory( CoreApp.getAppServices().storeService.getStore() );
		// Finally, set the container:
		this.setContainer( builder.build() );
	}
}

// Always export a 'new' instance so it immediately evokes:
export default new MyApp();

//ReactDOM.render(<AppBoot/>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();

if ( process.env.REACT_APP_CHANNEL_RELEASE === "1" ) {
	const HookBtn = ( lang: string ) => {
		const langBtns = window.document.getElementsByClassName( `nav-link ${ lang }-link` );
		const changeLang = ( e: any ) => {
			e.preventDefault();
			let loc = window.location.href;
			if ( loc.indexOf( "/en/" ) != -1 ) {
				loc = loc.replace( "/en/", "/ar/" );
			} else if ( loc.indexOf( "/ar/" ) != -1 ) {
				loc = loc.replace( "/ar/", "/en/" );
			}
			window.location.href = loc;
		};
		if ( langBtns ) {
			for ( let i = 0; i < langBtns.length; i++ ) {
				const btn = langBtns[ i ];
				btn.addEventListener( "click", changeLang );
			}
		}
	};
	HookBtn( "en" );
	HookBtn( "ar" );
}
